export const tags = {
    placT: [
        'monumento',
        'templo',
        'museo',
        'naturaleza',
    ],
    act:[
        'recracional',
        'cultural',
        'servicios',
        
    ]
}
export const  days= [
    'lunes', 'martes', 'miercoles','jueves','viernes','sabado','domingo'
]